var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightCircleB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.45 20L17.8 11.35L15.7 13.5L22.2 20L15.7 26.5L17.8 28.65L26.45 20ZM40 20C40 22.7333 39.475 25.3167 38.425 27.75C37.375 30.1833 35.9417 32.3083 34.125 34.125C32.3083 35.9417 30.1833 37.375 27.75 38.425C25.3167 39.475 22.7333 40 20 40C17.2333 40 14.6333 39.475 12.2 38.425C9.76667 37.375 7.65 35.9417 5.85 34.125C4.05 32.3083 2.625 30.1833 1.575 27.75C0.524999 25.3167 -7.5475e-07 22.7333 -8.74228e-07 20C-9.95163e-07 17.2333 0.524999 14.6333 1.575 12.2C2.625 9.76667 4.05 7.65 5.85 5.85C7.65 4.05 9.76666 2.625 12.2 1.575C14.6333 0.524997 17.2333 -7.53293e-07 20 -8.74228e-07C22.7333 -9.93706e-07 25.3167 0.524997 27.75 1.575C30.1833 2.625 32.3083 4.05 34.125 5.85C35.9417 7.65 37.375 9.76666 38.425 12.2C39.475 14.6333 40 17.2333 40 20Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightCircleB);
export default __webpack_public_path__ + "static/media/arrow-right-circle-b.1024db7f1fcc84aa04f1659781d44c8f.svg";
export { ForwardRef as ReactComponent };